import React from 'react';
import {Link} from 'react-router-dom';
import './MobileNav.css';
import dtn from './dtn.svg';
import menu from './menu.svg';

export const MobileNav = (props) => {
	return(
		<header className='mobileNav mob-links'>

				<img id='menu'src={menu} alt="icon" onClick={props.handleNavBar}/>
				<div className='caption'>
					<h4>MUSIC BLOG. ALL RIGHTS RESERVED | MELBOURNE, AUSTRALIA | 2020</h4>
				</div>
				<Link to='/dtn'>
					<img id='dtn'src={dtn} alt="icon"/>
				</Link>

		</header>
	);

}